import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
} from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Data } from "../shared/data";
import { NextaSelectionBaseList } from "../shared/nexta-crud/nexta-selection-base-list";
import { NotificationService } from "../shared/notification.service";
import { Authority } from "./authority";
import { AuthorityService } from "./crud.service";

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: "./authority-list.component.html",
	standalone: false,
})
export class AuthorityListComponent extends NextaSelectionBaseList<Authority> {
	constructor(
		router: Router,
		authorityService: AuthorityService,
		notificationService: NotificationService,
		acrossPagesData: Data,
		route: ActivatedRoute,
		cdr: ChangeDetectorRef,
		fb: UntypedFormBuilder,
	) {
		super(
			"/behoerden",
			router,
			authorityService,
			notificationService,
			route,
			acrossPagesData,
			"authorities",
			cdr,
			fb,
		);
	}
}
